import phoneIcon from "../assets/phoneIcon.svg";
import mailIcon from "../assets/mail.png";
import websiteIcon from "../assets/globeIcon.svg";
import { useLocation } from "react-router-dom";
import CountryStore from "../store/CountryStore";
import CategoryStore from "../store/CategoryStore";

function CardComponent(){
  const globalCountry = CountryStore((state) => state.country);
  const globalCategory = CategoryStore((state) => state.category);
  const location = useLocation();
  const formattedCountry = globalCountry.replace(/\s+/g, '-').toLowerCase();
  return (
      <div className="grid grid-cols-5 gap-0 pb-4 mt-auto">
    <div className={`col-span-1 text-sm text-[#4E5562] ${location.pathname === `/${formattedCountry}` ? "sm:mr-4 md:mr-4 lg:mr-4 xl:mr-4" : "sm:mr-4 md:mr-4 lg:mr-6 xl:mr-4" } `}>Connect</div>
    <div className={`col-span-4 flex items-center space-x-2 ${location.pathname === `/${formattedCountry}` ? "ml-1 sm:ml-3 md:ml-9 lg:ml-9 xl:ml-8" : "ml-1 sm:ml-3 md:ml-9 lg:ml-6 xl:ml-6"} `}>
      <img src={phoneIcon} alt="phone Icon" className="w-4 h-4" />
      <img src={mailIcon} alt="mail Icon" className="w-4 h-4" />
      <img src={websiteIcon} alt="website Icon" className="w-4 h-4" />
    </div>
  </div>
  )
}

export default CardComponent;